import {
  type IconSet,
  IconNameEnum,
  defaultIcons,
  defaultCarIcons,
} from "@b2bportal/core-themes";
import addTraveler from "../assets/icons/add-traveler.svg?react";
import Airplane from "../assets/icons/airplane.svg?react";
import apparel from "../assets/icons/apparel.svg?react";
import ArrowRight from "../assets/icons/arrow-right.svg?react";
import auto from "../assets/icons/auto.svg?react";
import automotive from "../assets/icons/automotive.svg?react";
import Back from "../assets/icons/back.svg?react";
import Bed from "../assets/icons/bed.svg?react";
import bookingSuccess from "../assets/icons/booking-success.svg?react";
import Calendar from "../assets/icons/calendar.svg?react";
import carReservation from "../assets/icons/car-reservation.svg?react";
import Car from "../assets/icons/car.svg?react";
import CarouselLeftArrow from "../assets/icons/carousel-left-arrow.svg?react";
import CarouselRightArrow from "../assets/icons/carousel-right-arrow.svg?react";
import Charge from "../assets/icons/Charge.svg?react";
import CheckFilled from "../assets/icons/check-filled.svg?react";
import Check from "../assets/icons/Check.svg?react";
import ChevronDown from "../assets/icons/chevron-down.svg?react";
import ChevronLeft from "../assets/icons/chevron-left.svg?react";
import ChevronRight from "../assets/icons/chevron-right.svg?react";
import ChevronUp from "../assets/icons/chevron-up.svg?react";
import circleCheckedItem from "../assets/icons/circle-checked-item.svg?react";
import Clock from "../assets/icons/clock.svg?react";
import Close from "../assets/icons/Close.svg?react";
import DarkChevronDown from "../assets/icons/dark-chevron-down.svg?react";
import DarkChevronUp from "../assets/icons/dark-chevron-up.svg?react";
import DollarCircle from "../assets/icons/DollarCircle.svg?react";
import Edit from "../assets/icons/edit.svg?react";
import electronic from "../assets/icons/electronic.svg?react";
import ExternalLink from "../assets/icons/external-link.svg?react";
import Filters from "../assets/icons/filters.svg?react";
import food from "../assets/icons/food.svg?react";
import Generic from "../assets/icons/GenericFareDetail.svg?react";
import Glass from "../assets/icons/glass.svg?react";
import Guest from "../assets/icons/guest.svg?react";
import health from "../assets/icons/health.svg?react";
import homepagePerkCenter from "../assets/icons/homepage-perk-center.svg?react";
import homepagePerkLeft from "../assets/icons/homepage-perk-left.svg?react";
import homepagePerkRight from "../assets/icons/homepage-perk-right.svg?react";
import hotelMapPin from "../assets/icons/hotel-map-pin.svg?react";
import hotelReservation from "../assets/icons/hotel-reservation.svg?react";
import Image from "../assets/icons/image.svg?react";
import Info from "../assets/icons/Info.svg?react";
import Lock from "../assets/icons/lock.svg?react";
import MapPin from "../assets/icons/map-pin.svg?react";
import Minus from "../assets/icons/minus.svg?react";
import outdoors from "../assets/icons/outdoor.svg?react";
import Plus from "../assets/icons/plus.svg?react";
import PriceMatch from "../assets/icons/price-match.svg?react";
import Refundable from "../assets/icons/refundable.svg?react";
import remove from "../assets/icons/remove.svg?react";
import Rewards from "../assets/icons/rewards.svg?react";
import Sort from "../assets/icons/sort.svg?react";
import travel from "../assets/icons/travel.svg?react";
import TriangleDown from "../assets/icons/triangle-down.svg?react";
import Unavailable from "../assets/icons/Unavailable.svg?react";
import World from "../assets/icons/world.svg?react";
import { hotelAmenitiesIcon } from "./hotelAmenities";

/*
 * NEED TO ADD TENANT SPECIFIC ICONS?
 * Add enum to `app/src/theme/types` then add icon here.
 */
export const lightModeIcons: IconSet = {
  ...defaultCarIcons,
  [IconNameEnum.bed]: Bed,
  [IconNameEnum.car]: Car,
  [IconNameEnum.info]: Info,
  [IconNameEnum.dropdownTriangle]: TriangleDown,
  [IconNameEnum.dropdownArrow]: ChevronDown,
  [IconNameEnum.carouselRightArrow]: ChevronRight,
  [IconNameEnum.carouselLeftArrow]: ChevronLeft,
  [IconNameEnum.backIcon]: Back,
  [IconNameEnum.actionIcon]: ChevronRight,
  [IconNameEnum.checkFilled]: CheckFilled,
  [IconNameEnum.fareDetailsAvailable]: CheckFilled,
  [IconNameEnum.fareDetailsUnavailable]: Unavailable,
  [IconNameEnum.fareDetailsCharge]: Charge,
  [IconNameEnum.fareDetailsGeneric]: Generic,
  [IconNameEnum.filter]: Filters,
  [IconNameEnum.close]: Close,
  [IconNameEnum.nextIcon]: ChevronRight,
  [IconNameEnum.airplane]: Airplane,
  [IconNameEnum.check]: Check,
  [IconNameEnum.calendar]: Calendar,
  [IconNameEnum.plus]: Plus,
  [IconNameEnum.minus]: Minus,
  [IconNameEnum.calendarSeparatorIcon]: ArrowRight,
  [IconNameEnum.mapPin]: MapPin,
  [IconNameEnum.passengerSelection]: Guest,
  [IconNameEnum.edit]: Edit,
  [IconNameEnum.chevronDown]: ChevronDown,
  [IconNameEnum.chevronUp]: ChevronUp,
  [IconNameEnum.guest]: Guest,
  [IconNameEnum.search]: Glass,
  [IconNameEnum.externalLink]: ExternalLink,
  [IconNameEnum.clock]: Clock,
  [IconNameEnum.world]: World,
  [IconNameEnum.dollar]: DollarCircle,
  [IconNameEnum.sort]: Sort,
  [IconNameEnum.rewards]: Rewards,
  [IconNameEnum.darkChevronDown]: DarkChevronDown,
  [IconNameEnum.darkChevronUp]: DarkChevronUp,
  [IconNameEnum.refundable]: Refundable,
  [IconNameEnum.priceMatch]: PriceMatch,
  [IconNameEnum.carouselLeftArrow]: CarouselLeftArrow,
  [IconNameEnum.carouselRightArrow]: CarouselRightArrow,
  [IconNameEnum.circleCheckedItem]: circleCheckedItem,
  [IconNameEnum.image]: Image,
  [IconNameEnum.lock]: Lock,
  [IconNameEnum.hotelMapPin]: hotelMapPin,
};

export const darkModeIcons: IconSet = {
  ...defaultIcons,
  ...defaultCarIcons,
  ...lightModeIcons,
};

export const icons: IconSet = {
  ...defaultIcons,
  ...lightModeIcons,
  hotelAmenities: hotelAmenitiesIcon,
  homepagePerkLeft: homepagePerkLeft,
  homepagePerkRight: homepagePerkRight,
  homepagePerkCenter: homepagePerkCenter,
  homepagePerkHealth: health,
  homepagePerkApparel: apparel,
  homepagePerkElectronic: electronic,
  homepagePerkFood: food,
  homepagePerkTravel: travel,
  homepagePerkAuto: auto,
  homepagePerkAutomotive: automotive,
  homepagePerkOutdoors: outdoors,
  hotelReservation,
  carReservation,
  addTraveler,
  remove,
  bookingSuccess,
};

export default icons;
